import { createSelector } from 'reselect';
import { productSelector } from 'selectors/page/product/productSelector';

const bottomNavHiddenSelector = createSelector(productSelector, product => !!product?.bottomNavHidden);

export { bottomNavHiddenSelector };
